import { render, staticRenderFns } from "./SpecialGifts.vue?vue&type=template&id=20ccd884"
import script from "./SpecialGifts.vue?vue&type=script&lang=js"
export * from "./SpecialGifts.vue?vue&type=script&lang=js"
import style0 from "./SpecialGifts.vue?vue&type=style&index=0&id=20ccd884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports